module.exports = __webpack_public_path__ + "fonts/sourcesansproblack.add873a7.woff";